<div class="line-guage-chart-section">
  <svg width="0" height="0">
    <defs>
      <linearGradient id="linear">
        <stop offset="0%" stop-color="#39CB2C" />
        <stop offset="50%" stop-color="#FFE100" />
        <stop offset="100%" stop-color="#FE3A2F" />
      </linearGradient>
    </defs>
  </svg>
</div>
